<div class="content">
	<div *ngIf="datafiles">
		<table class="datafile-table">
			<tr>
				<th>Filename</th>
				<th>Size</th>
				<th>Import Date ▼</th>
				<th>Exception</th>
			</tr>
			<tr *ngFor="let datafile of datafiles; let i = index" class="listing-item" [class.dayspacer]="(datafiles.length > i + 1) && (datafile.imported.clone().startOf('day') > datafiles[i + 1].imported.clone().startOf('day'))">
				<td><a (click)="DownloadFile(datafile)" href="javascript:void(0)"><i class="icon-doc"></i> {{datafile.filename | truncatedfile}}</a></td>
				<td>{{ datafile.size | filesize }}</td>
				<td>{{ datafile.imported | datetime : "local" }}</td>
				<td><a *ngIf="datafile.exception" (click)="ShowException(datafile.exception)" href="javascript:void(0)" [title]="datafile.exception">{{ datafile.exception | shortexception }}...</a></td>
			</tr>
		</table>
	</div>
</div>

<ng-template #exceptionModal let-c="close">
	<div class="modal-header">
		<h4 class="modal-title">Exception detail</h4>
		<button type="button" class="close" aria-label="Close" (click)="c()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<h3>Exception</h3>
		<pre>{{selectedException | json}}</pre>
		<div *ngIf="selectedExceptionStack">
			<h3>Stack</h3>
			<pre>{{selectedExceptionStack}}</pre>
		</div>
		<div *ngIf="selectedExceptionSubStack">
			<h3>Detail stack</h3>
			<pre>{{selectedExceptionSubStack}}</pre>
		</div>
	</div>
</ng-template>